module.exports = __webpack_public_path__ + "static/fonts/greenmile/sizealias/fonts/sizealias.eot";